<template>
<div >
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Daños</li>
						</ol>
						<div class="title">
							<h1>Daños</h1>
						</div>
					</div>

					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						<div class="filter">
							<label>Cliente</label>
							<select class="form-control" 
								v-model="filters.client_id" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option v-for="client in clients" :key="client.id" :value="client.id">{{client.name}}</option>
							</select>           
						</div>
						
						<div class="filter">
							<label>Estado actual</label>
							<select class="form-control" 
								v-model="filters.status" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="ACTIVE">Activos</option>
								<option value="REPAIRED"> Reparados</option>
							</select>           
						</div>
						
					</div>

					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Chasis</td>
							<td>Vehículo</td>
							<td>Cliente</td>
							<td>Estado</td>
						</tr>
						
						<router-link tag="tr" v-for="item of list" :key="item.id" :to="`/cars/${item.car.id}`" >
							<td>{{item.car.chassis_number}}</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.car.brand.title}}</span>
									<span >{{item.car.model}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.car.client.name}}</span>
									<span >{{item.car.client.business_name}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.description}}</span>
									<!-- <span >{{item.parkingSlot.code}}</span> -->
								</div>
							</td>
							<td>
								<div class="tc">
									<span><div class="status-point" :class="{'red':item.status==0, 'green':item.status==1}"></div> {{item.statusText}}</span>
								</div>
							</td>
						</router-link>
						
					</table>


					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado vehículos</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>

				</div>
			</div>

			
		</div>
	</div>
	
	<CarPreview ref="carPreview"></CarPreview>

	<CarModalForm ref="carForm" @updated="load()" ></CarModalForm>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'
import { buildExportUrl } from '@/lib/exportsUrl'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import CarPreview from '@/views/cars/CarPreview'
import CarModalForm from '@/views/cars/CarModalForm'

export default {
	name: 'cars',
	components:{
		Navbar,
		Loader,
		CarPreview,
		CarModalForm
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			clients:[],
			loading: true,
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		console.log(this.filters);
		this.load();
	},
	methods:{
		exportData(){
			window.open(buildExportUrl('export-cars', this.$route.query), '_blank');
		},
		load(){
			this.$apollo.query({
				query: gql`query (	$first: Int!, 
									$page: Int, 
									$search: String, 
									$status: String, 
									$client_id: ID, 
					) {
					damages(
							first: $first, 
							page: $page, 
							search: $search, 
							status: $status, 
							client_id: $client_id, 
						) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							car{
								id
								chassis_number
								brand{
									title
								}
								model
								client{ name business_name }
							}
							description
							statusText
							status
						}
					}
					clientsAll{
						id
						name
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					status: this.filters.status,
					client_id: this.filters.client_id,
				},
			})
			.then((data) => {
				this.list = data.data.damages.data;
				this.pagination.total = data.data.damages.paginatorInfo.total;
				this.clients = data.data.clientsAll;
				this.loading = false
			});
		},
		changeFilter(){
			this.$nextTick(()=>{
				this.updateFilters()
			})
		}

	}
}


</script>

<style>

</style>
